import {all, call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";
import Constants from "../services/Constants";
import {buildStatusCountersParams, buildTypeCountersParams} from "../helpers/filters";

function* fetchInterventions(params) {
  try {
    let parameters = params.parameters;

    const statusCountersParams = buildStatusCountersParams(params);
    const typeCountersParams = buildTypeCountersParams(params);

    Object.keys(params.filters).forEach(key => {
      if ((params.filters[key] !== undefined) && (params.filters[key].length > 0 || Boolean(params.filters[key]))) {
        parameters[key] = params.filters[key];
      }
    });

    const [interventions, statusCountersData, typeCountersData] = yield all([
      call(() => Api.get('/interventions', parameters)),
      call(() => Api.get('/interventions/count', statusCountersParams)),
      call(() => Api.get('/interventions/count', typeCountersParams)),
    ]);

    const statusCounters = statusCountersData.body.interventionStatus;
    const typeCounters = typeCountersData.body.type;

    yield put({type: 'FETCH_INTERVENTIONS.SUCCESS', interventions, statusCounters, typeCounters});
  } catch (error) {
    yield put({type: 'FETCH_INTERVENTIONS.FAILURE', error});
  }
}

function* fetchInterventionsOverview(params) {
  try {
    let parameters = params.parameters;

    Object.keys(params.filters).forEach(key => {
      if ((params.filters[key] !== undefined) && params.filters[key].length > 0) {
        parameters[key] = params.filters[key];
      }
    });

    const interventions = yield call(function () {
      return Api.get('/interventions/overview', parameters)
    });
    yield put({type: 'FETCH_INTERVENTIONS_OVERVIEW.SUCCESS', interventions});
  } catch (error) {
    yield put({type: 'FETCH_INTERVENTIONS_OVERVIEW.FAILURE', error});
  }
}


export function* watchFetchInterventions() {
  yield takeEvery('FETCH_INTERVENTIONS.REQUEST', fetchInterventions)
}

export function* watchFetchInterventionsOverview() {
  yield takeEvery('FETCH_INTERVENTIONS_OVERVIEW.REQUEST', fetchInterventionsOverview)
}



// WEBPACK FOOTER //
// ./src/sagas/interventions.js